const translations = {
  title: {},
  msg: {
    welcome: 'Welcome',
    loginMsg: 'Welcome again to TopicNexus! login and try its nice features',
    signupMsg: 'Welcome to TopicNexus! signup and try its nice features',
    enterEmailFP: 'Enter your email to send recovery token to you',
    or: 'Or',
    resetPassword:
      'Enter the token received on your email, and your new password',
    uploadPhoto: 'Upload Photo',
    uploadPhotoMsg:
      'Upload your photo, or just skip and continue to use the app',
    uploadPhotoAlt: 'Your Uploaded File',
    updateData: 'Update My Data',
    updatePassword: 'Update My Password',
    deleteAccount: 'Delete My Account',
    confirmEmail: 'Confirm My E-Mail',
    updatePhoto: 'Update My Photo',
    userNoPosts: "{{name}} Haven't posted yet !",
    selectCategories: 'Select Categories',
    noPosts: 'No Posts Available',
    noUsers: 'No Users Available',
    noCategories: 'No Categories Available',
    attachmentLimit: 'You can attach only 3 files at most',
    addingPost: 'Adding post ...',
    editingPost: 'Editing post ...',
  },
  label: {
    email: 'E-Mail',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    name: 'Name',
    bio: 'Bio',
    noAccount: "doesn't have an account?",
    haveAccount: 'Already have an account?',
    token: 'Your Token',
    settings: 'Settings',
    home: 'Home',
    saved: 'Saved Items',
    confirmToken: 'Confirm Token',
    recommendedUsers: 'Recommended Users',
    categories: 'Categories',
    allCategories: 'All Categories',
    mostPopular: 'Most Popular',
    comments: 'Comments',
    addComment: 'Add New Comment',
    followersNum: 'Followers: {{num}}',
    followingNum: 'Following: {{num}}',
    followers: 'Followers',
    following: 'Following',
    userPosts: '{{name}} posts',
    myProfile: 'My Profile',
    updateMyProfile: 'Update My Profile',
    addPost: 'Add New Post',
    editPost: 'Edit Post',
    title: 'Title',
    content: 'Content',
    attachments: 'Attachments',
    followingPosts: 'Following Posts',
    sortOptionsDate: 'Date',
    sortOptionsLike: 'Most Liked',
    sortOptionsComment: 'Most Comments',
    likedBy: 'Liked By',
  },
  action: {
    login: 'Login',
    signup: 'Signup',
    logout: 'Logout',
    forgotPassword: 'Forgot Your Password?',
    send: 'SEND',
    resetPassword: 'Reset Your Password',
    noReceivedToken: "Didn't Receive a Token?",
    upload: 'Upload',
    skip: 'Skip',
    choosePhoto: 'Choose Photo',
    save: 'Save',
    delete: 'Delete',
    confirm: 'Confirm',
    resendToken: 'Resend Token',
    add: 'Add',
    edit: 'Edit',
    seeAll: 'See All',
    view: 'View',
    follow: 'Follow',
    unfollow: 'Unfollow',
    loadMoreCategories: 'Load More Categories',
    attachFiles: 'Attach Files',
    remove: 'Remove',
    sortPosts: 'Sort Posts',
    download: 'Download',
    cancel: 'Cancel',
  },
  validateMsg: {
    emailRequired: 'E-Mail is required',
    emailInvalid: 'Please provide a valid email',
    passwordRequired: 'Password is required',
    confirmPasswordRequired: 'Confirm Password is required',
    shortPassword: 'Password should be at least 6 characters long',
    noMatchedPasswords: "Passwords doesn't match",
    tokenRequired: 'Token is required',
    emptyComment: 'Please type comment',
    postTitleRequired: 'Post title is required',
    postContentRequired: 'Post content is required',
  },
};

export default translations;
